module.exports = __webpack_public_path__ + "static/media/bg-pattern@2x@2x.e6775046.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bg-pattern@2x@2x.png
// module id = 1260
// module chunks = 1